import {
  clinicianUpgradeModalOpenAtom,
  practiceUpgradeModalOpenAtom,
} from '@/atoms/paywallAtoms';
import {
  resolveEvidenceUpgradeModalTarget,
  type EvidenceUpgradeModalTarget,
} from '@/features/growth/deprecate-evidence-plus/resolveEvidenceUpgradeModalTarget';
import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

export type OpenEvidenceUpgradeModalOptions = {
  isScribePlusUser: boolean;
  isClinicianTrialUser: boolean;
  isPracticeUpgradeTarget: boolean;
};

export function useOpenEvidenceUpgradeModal() {
  const setClinicianUpgradeModalOpen = useSetAtom(clinicianUpgradeModalOpenAtom);
  const setPracticeUpgradeModalOpen = useSetAtom(practiceUpgradeModalOpenAtom);

  const openModalForTarget = useCallback(
    (target: EvidenceUpgradeModalTarget) => {
      switch (target) {
        case 'clinician':
          setClinicianUpgradeModalOpen(true);
          break;
        case 'practice':
          setPracticeUpgradeModalOpen(true);
          break;
      }
    },
    [setClinicianUpgradeModalOpen, setPracticeUpgradeModalOpen]
  );

  const openEvidenceUpgradeModal = useCallback(
    ({
      isScribePlusUser,
      isClinicianTrialUser,
      isPracticeUpgradeTarget,
    }: OpenEvidenceUpgradeModalOptions) => {
      const target = resolveEvidenceUpgradeModalTarget({
        isScribePlusUser,
        isClinicianTrialUser,
        isPracticeUpgradeTarget,
      });
      openModalForTarget(target);
    },
    [openModalForTarget]
  );

  return { openEvidenceUpgradeModal };
}
